/** Platform-admin routes. These do not require a selected OrganizationMember. */
export function isSuperAdminPath(pathname: string): boolean {
  return pathname === "/super-admin" || pathname.startsWith("/super-admin/");
}
